"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireDefault(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _immutable = require("immutable");

var _taskTypes = require("crm_ui/constants/taskTypes");

var _setTaskType = function _setTaskType(options, type) {
  return options.setIn(['metadata', 'taskType'], type);
};

function _default(Component) {
  var SmartTask =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(SmartTask, _PureComponent);

    function SmartTask() {
      var _this;

      (0, _classCallCheck2.default)(this, SmartTask);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SmartTask).call(this));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(SmartTask, [{
      key: "getMatchIndex",
      value: function getMatchIndex(taskSubject, taskTypeText) {
        return taskSubject.toLowerCase().indexOf(taskTypeText.toLowerCase());
      }
    }, {
      key: "getFirstTextMatch",
      value: function getFirstTextMatch(taskTypes, subject) {
        var _this2 = this;

        return taskTypes.reduce(function (closestMatch, task) {
          var taskMatchIdx = _this2.getMatchIndex(subject, task.text);

          if (taskMatchIdx === -1) {
            return closestMatch;
          }

          if (!closestMatch.text) {
            return task;
          }

          var closestMatchIdx = _this2.getMatchIndex(subject, closestMatch.text);

          return taskMatchIdx < closestMatchIdx ? task : closestMatch;
        }, {});
      }
    }, {
      key: "getTextAndType",
      value: function getTextAndType(action) {
        return {
          text: _I18n.default.text("tasksV2.smartTask.type." + action),
          type: action
        };
      }
    }, {
      key: "handleSetTaskTypeBySubject",
      value: function handleSetTaskTypeBySubject(_ref) {
        var _this3 = this;

        var options = _ref.options,
            subject = _ref.subject;
        var taskTypes = [_taskTypes.CALL, _taskTypes.EMAIL].reduce(function (acc, type) {
          return acc.push(_this3.getTextAndType(type));
        }, (0, _immutable.List)());
        var match = this.getFirstTextMatch(taskTypes, subject);

        if (match.type) {
          return _setTaskType(options, match.type);
        }

        return options;
      }
    }, {
      key: "handleSetTaskTypeByParam",
      value: function handleSetTaskTypeByParam(_ref2) {
        var options = _ref2.options,
            params = _ref2.params;

        if (!params) {
          return options;
        }

        var taskType = params.taskType;

        if (!taskType) {
          return options;
        }

        return options;
      }
    }, {
      key: "handleProcessSmartTaskOptions",
      value: function handleProcessSmartTaskOptions(_ref3) {
        var subject = _ref3.subject,
            params = _ref3.params;
        var options = (0, _immutable.fromJS)({
          metadata: {
            subject: subject
          }
        });
        options = this.handleSetTaskTypeByParam({
          options: options,
          params: params
        });
        return this.handleSetTaskTypeBySubject({
          options: options,
          subject: subject
        });
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          processSmartTaskOptions: this.handleProcessSmartTaskOptions
        }));
      }
    }]);
    return SmartTask;
  }(_PureComponent2.default);

  return SmartTask;
}

module.exports = exports.default;